import React, { FC } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

interface Props {
  path: string;
}
export const Layout: FC<Props> = ({ path }) => {
  return (
    <Box width="100%" height="100vh">
      <Outlet />
    </Box>
  );
};
